import React, { useEffect, useState } from 'react';
import { Container, Box, Typography } from '@mui/material';
import { NavMenu } from './NavMenu';

export const Layout = (props) => {
  const [version, setVersion] = useState('');

  useEffect(() => {
    fetch('/api/version')
      .then(response => response.json())
      .then(data => setVersion(data.version))
      .catch(error => console.error('Failed to fetch version:', error));
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <NavMenu />
      <Container maxWidth="xl" style={{ flex: 1, paddingBottom: '40px' }}>
        {props.children}
      </Container>
      {version && (
        <Box
          component="footer"
          sx={{
            py: 1,
            px: 2,
            mt: 'auto',
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[200]
                : theme.palette.grey[800],
            textAlign: 'center'
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Version: {version}
          </Typography>
        </Box>
      )}
    </div>
  );
};
